import axios from "axios";
import {getToken} from "./TokenRepository";

const createConfig = () => {
    return {
        headers: {
            'Api-Key': `Bearer ${getToken()}`
        },
    };
}

export const getTime = async () => {
    const result = await axios.get(`${process.env.REACT_APP_API_URL}/time`, createConfig());
    return result.data;
}